import get from 'lodash-es/get';

const systemSounds = {info:true, ping:true, error:true, success:true, warning:true, blocked:true, tada:true, new: true};

const nativeEvents = [
	'abort',
	'canplay',
	'canplaythrough',
	'durationchange',
	'emptied',
	'ended',
	'error',
	'loadeddata',
	'loadedmetadata',
	'loadstart',
	'pause',
	'play',
	'playing',
	'progress',
	'ratechange',
	'seeked',
	'seeking',
	'stalled',
	'suspend',
	'timeupdate',
	'volumechange',
	'waiting'
];


export default class AudioAPI {

	constructor(host, optionsPath, el) {
		this._audio = el || document.createElement('audio');
		this._isSystem = !el;		
		this._host = host;		
		nativeEvents.forEach((event) => {
			this._audio.addEventListener(event, (e) => { 
				host.fire(`audio${event.charAt(0).toUpperCase() + event.slice(1)}`, this._host, {event: e, audio: this});
			});
		});

		host.on('destroy', () => {
			if(this._audio){
				this.stop();
				this._audio.remove();															
				delete this._audio;
				delete this._host;
			}
		});

		host.once('init', () => {
			this.applyOptions(get(host,optionsPath));
		});

		host.on('init', () => {
			if(this.getAutoplay() == 'onComponentReload'){
				this.play();
			}
		});
	}

	getUrl(){
		return this._url;
	}

	setUrl(url){
		if(this._url!==url){
			this._url=url;

			if(url){
				if(systemSounds[url]){
					url = `themes/sound/${url}.mp3`;
				}else if(url.toLowerCase().startsWith('dropbox://')){
					const dburl = url.substring(10);
					const lastSlashIndex = dburl.lastIndexOf('/');
					let path = dburl.substring(0, lastSlashIndex);
					const name = dburl.substring(lastSlashIndex + 1);			
					url = this._host.dropBoxGetFileUrl({path,name});
				}			
			}else{
				url='';
			}

			this._audio.src = url;
			this._host.fire('audioUrlChange', this._host, {url, audio: this});
			if(this.getAutoplay() == 'onUrlChange'){
				this.play();
			}			
		}
	}

	applyOptions(options={}){

		if(!this._options || this._options.loop!==options.loop){
			this.setLoop(options.loop||false);
		}

		if(!this._options || this._options.volume!==options.volume){
			this.setVolume(options.volume||1);
		}

		if(!this._options || this._options.muted!==options.muted){
			this.setMuted(options.muted||false);
		}

		if(!this._options || this._options.currentTime!==options.currentTime){
			this.setCurrentTime(options.currentTime||0);
		}

		if(!this._options || this._options.autoplay!==options.autoplay){
			this.setAutoplay(options.autoplay);
		}

		if(!this._options || this._options.url!==options.url){
			this.setUrl(options.url);
		}

		if(!this._options || this._options.visible!==options.visible){
			this.setControls(options.visible||false);
		}

		this._options = options;
		this._host.fire('audioOptionsChange', this._host, {options, audio: this});
	}

	play(){
		this._audio.play();
	}

	pause(){
		this._audio.pause();
	}

	stop(){
		this._audio.pause();
		this._audio.currentTime = 0;
	}

	setVolume(volume){
		this._audio.volume = volume;
	}

	getVolume(){
		return this._audio.volume;
	}

	setMuted(muted){
		this._audio.muted = muted;
	}

	isMuted(){
		return this._audio.muted;
	}

	setLoop(loop){
		this._audio.loop = loop;
	}

	isLoop(){
		return this._audio.loop;
	}

	setCurrentTime(time){
		this._audio.currentTime = time;
	}

	getCurrentTime(){
		return this._audio.currentTime;
	}

	getDuration(){
		return this._audio.duration;
	}

	isPaused(){
		return this._audio.paused;
	}

	isEnded(){
		return this._audio.ended;
	}

	isBuffered(){
		return this._audio.buffered;
	}

	isSeekable(){
		return this._audio.seekable;
	}

	isPlayed(){
		return this._audio.played;
	}

	getReadyState(){
		return this._audio.readyState;
	}

	getNetworkState(){
		return this._audio.networkState;
	}

	isSeeking(){
		return this._audio.seeking;
	}

	getError(){
		return this._audio.error;
	}

	setAutoplay(autoplay){
		this._autoplay = autoplay;
		this._host.fire('audioAutoplayChange', this._host, {autoplay, audio: this});
	}

	getAutoplay(){
		return this._autoplay;
	}

	setControls(controls){
		if(!this._isSystem){
			this._audio.controls = controls;
			this._host.fire('audioControlsChange', this._host, {controls, audio: this});
		}
	}

	getControls(){
		return this._audio.controls;
	}
}